export const SsoLogoutPageDisplayTextEn = {
    alertStaticText: 'You have logged out of My Lincoln Portal.',
    bodySection1: `To log back in to My Lincoln Portal, visit your company internal site.`,
};
